import { createUseStyles } from "react-jss";
import {colors} from "../../constants/colors";
import {breakpoints} from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    margin: "0px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "20px",
    },
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    marginTop: "4px",
    marginBottom: "24px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginBottom: "15px"
    },
  },
  descriptiveText: {
    color: colors.mediumGrey,
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "28px"
  },
  starText: {
    fontWeight: "400",
    fontSize: "16px",
    marginBottom: "20px"
  },
  footerItemWrapper: {
    padding: "24px",
    display: "flex",
    gap: "16px",
    "& path": {
      stroke: theme.buttons.defaultLink.color,
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "14px",
    },
  },
  descText: {
    marginBottom: "10px !important"
  },
  footerItem: {
    "& h6": {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      color: colors.lightBlack,
      marginBottom: "8px",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.mediumGrey,
      marginBottom: "0px",
    },
  },
  link: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: theme.buttons.defaultLink.color,
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    textDecoration: "none",
    marginTop: "10px",
    width: "fit-content",
    "& path": {
      stroke: theme.buttons.defaultLink.color,
    },
  },
  link2: {
    extend: "link",
    marginTop: "0px"
  },
  divider: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 1,
    marginBottom: "6px"
  },
  phoneNumber: {
    fontWeight: 600
  }
}));

export default styles;
